import { Link } from "react-router";

export default function LockedPage() {
  return (
    <div className="space-y-6">
      <h1>账户已锁定</h1>
      <p>该账户尚未完成企业认证，暂时不能进行业务操作。</p>
      <p>请由账户所有者完成企业认证后再返回继续操作。</p>
      <p><Link to="/accounts">返回账户管理</Link></p>
    </div>
  );
}
